'use es6';

import Immutable from 'immutable';
import { cleanObject } from '../utils/formatters';
const EMPTY_LIST = Immutable.List();
const defaults = {
  category: '',
  companyName: '',
  firstPublishedAt: 0,
  credentials: EMPTY_LIST,
  iconUrl: '',
  id: 0,
  installed: false,
  installsCount: 0,
  name: '',
  offeringId: 0,
  recommendation: null,
  recommended: false,
  reviewSummary: null,
  sourceId: '',
  slug: '',
  tagline: ''
};
class ThinListing extends Immutable.Record(defaults) {
  constructor(values) {
    const copy = Object.assign({}, values);
    if (values.credentials) {
      copy.credentials = Immutable.List(values.credentials);
    }
    super(cleanObject(values));
  }
}
export default ThinListing;